<template>
<div>
	<main class="main ">
  <div
									class="d-flex justify-content-between align-items-center flex-column"
								>
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
								<div class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--11 bg-color--light--1">
									<h4 class="mb-3 font-weight-bold">{{$t("sidebar.userStatus")}}</h4>
									<hr />
    <div class="row justify-content-between">
									<div class="col-md-7">
										<div class="form-group">
											<label class="form__label  font-size--15 font-w--500">{{
												$t("register.jobclass") + "  :  "
											}}</label>
											<label
												v-if="jobClass == '0'"
												class="form__label  font-size--15 font-w--400"
												>{{$t('register.staff')}}</label
											>
											<label
												v-if="jobClass == '1'"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{$t('register.selfEmployment')}}</label
											>
											<label
												v-if="jobClass == '2'"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{$t('register.pensioner')}}</label
											>
										</div>
									</div>
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.job") + "  :  " }}</label
											>
											<label
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ job }}</label
											>
										</div>
									</div>
								</div>

								<div class="row justify-content-between">
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.income") + "  :  " }}</label
											>
											<!-- <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >{{ income }}</label
                      > -->
											<vue-numeric
												id="estimate_income"
												separator=","
												v-model="income"
												class="form-control"
												read-only
											></vue-numeric>
										</div>
									</div>
									<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.jobAddress") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ jobAddress }}</label
													>
												</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.jobPhoneNumber") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ jobPhoneNumber}}</label
													>
												</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.jobclass") + "  :  " }}</label
													>
													<label v-if="jobClass==0"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("register.jobClass.govermental") }}</label
													>
													<label v-if="jobClass==1"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("register.jobClass.libre") }}</label
													>
													<label v-if="jobClass==2"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("register.jobClass.Pensioner") }}}</label
													>
													<label v-if="jobClass==3"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("register.jobClass.private") }}</label
													>
													<label v-if="jobClass==4"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("register.jobClass.army") }}</label
													>
													<label v-if="jobClass==5"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("register.jobClass.Retired") }}</label
													>
												</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("supplier.status") + "  :  " }}</label
													>
													<label v-if="customerStatus=='00'"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("customer.watingForDocs") }}</label
													>
													<label v-if="customerStatus=='0'"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("customer.inprogressing") }}</label
													>
													<label v-if="customerStatus==1"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{$t("customer.confirmed") }}}</label
													>
													<label v-if="customerStatus==2"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.rejected") }}</label
													>
													<label v-if="customerStatus==3"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.conditionalConfirm") }}</label
													>
													<label v-if="customerStatus==4"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.customerCanceled") }}</label
													>
													<label v-if="customerStatus==5"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.defectiveDocuments") }}</label
													>
													<label v-if="customerStatus==6"
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ $t("customer.creditRatingExpiration") }}</label
													>
												</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.level") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ level}}</label
													>
												</div>
											</div>
											
								</div>
                                </div>
								</div>
								</div>
								</main>
                                </div>
								
</template>

<script>
import VueNumeric from "vue-numeric";
export default {
    mounted()
    {
		try
		{
			this.customer = JSON.parse(this.$store.getters.getCustomer)
		}
		catch
		{
			this.customer = this.$store.getters.getCustomer
		}
        
		
        this.income = this.customer.estimate_income
		this.level = this.customer.level
		this.status = this.customer.status
		this.credit_rank = this.customer.credit_rank
		this.job = this.customer.job
		this.jobClass = this.customer.job_class
		this.jobAddress=this.customer.job_address
		this.jobPhoneNumber=this.customer.job_phone_number
		this.jobClass=this.customer.job_class
		this.customerStatus=this.customer.status
		
    },
    data()
    {
        return {
            customer:null,
			
            income: "",
			level: "",
			status: "",
			credit_rank: "",
			job:"",
			customerStatus:'',
			jobAddress:'',
			jobPhoneNumber:'',
			jobClass:''
        }
    },
	components:{
		VueNumeric
	}

}
</script>

<style>

</style>